// 搜索模式
export enum ESearchMode {
    // [Description("默认模式")]
    Default = 0,

    // [Description("精准模式")]
    Precious = 1,

}